import { defineMessages } from 'react-intl';

export const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contentHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'rovo-settings-modal.title',
		defaultMessage: 'Rovo Settings',
		description: 'Title of the rovo settings modal',
	},
	contentHeader: {
		id: 'rovo-settings-modal.content-header',
		defaultMessage: 'Rovo Settings',
		description: 'Content header of the rovo settings modal',
	},
	searchPlaceholder: {
		id: 'rovo-settings-modal.search-settings-input-placeholder',
		defaultMessage: 'Search settings',
		description: 'Placehoder shown in the search settings input',
	},
});
